import React from 'react';
import { useAtomValue } from 'jotai';
import { commentListAtom } from '../atoms';
import { useReviewFeature } from '../hooks';
import { useReviewModal } from '../review-modal/use-review-modal';
import { FeedbackSubSection } from './feedback-sub-section';
import { Container } from './styled-components';
export const FeedbackPanel = () => {
  const commentList = useAtomValue(commentListAtom);
  const {
    enableCommentsFeedback
  } = useReviewFeature();
  const {
    addComment,
    editComment,
    deleteComment
  } = useReviewModal();
  return <Container>
      {enableCommentsFeedback && <FeedbackSubSection title="Comments" list={commentList} onAddFeedback={addComment} onEditFeedback={editComment} onDeleteFeedback={deleteComment} />}
    </Container>;
};